import { CanDeactivateFn } from '@angular/router';

export interface CollectionDirtyNavigationAware {
  canDeactivateCollectionRoute(nextUrl: string): boolean;
}

export const collectionDirtyNavigationGuard: CanDeactivateFn<
  CollectionDirtyNavigationAware
> = (component, _currentRoute, _currentState, nextState) =>
  component.canDeactivateCollectionRoute(nextState.url);
